import {
    VISTA_VENDEDOR_GET_COUNTERS_BEGIN,
    VISTA_VENDEDOR_GET_COUNTERS_SUCCESS,
    VISTA_VENDEDOR_GET_COUNTERS_FAILURE
} from './constants'
import { BFFAgent } from 'BFFAgent'
import { BUSINESS_UNIT, BUSINESS_UNIT_TABS } from 'vista-vendedor/Constants'

import axios from 'axios'

let cancel

export function getCounters(tipo, search) {
    return (dispatch) => {
        // Cancelar la solicitud anterior
        if (cancel) {
            cancel()
        }

        dispatch({
            type: VISTA_VENDEDOR_GET_COUNTERS_BEGIN,
        })

        const source = axios.CancelToken.source()
        cancel = source.cancel

        const isSavingPlan =
            tipo === BUSINESS_UNIT_TABS.find((op) => op.label === BUSINESS_UNIT.PlanAhorro).index
        const doRequest = isSavingPlan
            ? BFFAgent.SavingsPlan.getCounters(search, source.token)
            : BFFAgent.Catalogs.getCounters(search, source.token)

        return doRequest
            .then((res) => {
                if (res.data) {
                    dispatch({
                        type: VISTA_VENDEDOR_GET_COUNTERS_SUCCESS,
                        data: res.data,
                    })
                    return res.data.data
                } else {
                    dispatch({
                        type: VISTA_VENDEDOR_GET_COUNTERS_FAILURE,
                        data: {},
                    })
                    return Promise.reject()
                }
            })
            .catch((err) => {
                if (!axios.isCancel(err)) {
                    dispatch({
                        type: VISTA_VENDEDOR_GET_COUNTERS_FAILURE,
                        data: { error: err },
                    })
                    return Promise.reject(err)
                }
            })
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case VISTA_VENDEDOR_GET_COUNTERS_BEGIN:
            return {
                ...state,
                getCountersPending: true,
                counters: {}
            }

        case VISTA_VENDEDOR_GET_COUNTERS_SUCCESS:
            return {
                ...state,
                getCountersPending: false,
                counters: action.data
            }

        case VISTA_VENDEDOR_GET_COUNTERS_FAILURE:
            return {
                ...state,
                getCountersPending: false,
                counters: {}
            }

        default:
            return state
    }
}
